<template>
    <div>
        <b-row>
            <b-col md="6">
                <b-form-group label="Grup" label-for="configGroup" class="is-required">
                    <v-select-list
                        id="configGroup"
                        v-model="localValue.configGroup"
                        :options="configGroups"
                        label="label"
                        :reduce="(item) => item.value"
                        placeholder="Grup Seçin"
                        :state="getValidationState('configGroup')"
                    />
                    <b-form-invalid-feedback :state="getValidationState('configGroup')">
                        {{ errors.configGroup }}
                    </b-form-invalid-feedback>
                </b-form-group>

                <b-form-group label="Ayar Anahtarı" label-for="configKey" class="is-required">
                    <b-form-input id="configKey" v-model="localValue.configKey" placeholder="defaultTitle, siteName" :state="getValidationState('configKey')" />
                    <b-form-invalid-feedback :state="getValidationState('configKey')">
                        {{ errors.configKey }}
                    </b-form-invalid-feedback>
                </b-form-group>

                <b-form-group label="Veri Tipi" label-for="dataType">
                    <v-select-list id="dataType" v-model="localValue.dataType" :options="dataTypes" label="label" :reduce="(item) => item.value" placeholder="Tip Seçin" />
                </b-form-group>

                <b-form-group label="Değer" label-for="configValue">
                    <b-form-textarea v-if="localValue.dataType === 'json'" id="configValue" v-model="localValue.configValue" rows="5" placeholder='{"key": "value"}' />
                    <b-form-checkbox v-else-if="localValue.dataType === 'boolean'" id="configValue" v-model="configValueAsBoolean" switch>
                        {{ configValueAsBoolean ? "Açık" : "Kapalı" }}
                    </b-form-checkbox>
                    <b-form-spinbutton v-else-if="localValue.dataType === 'number'" id="configValue" v-model="configValueAsNumber" />
                    <b-form-input v-else id="configValue" v-model="localValue.configValue" placeholder="Ayar değeri" />
                </b-form-group>
            </b-col>

            <b-col md="6">
                <b-form-group label="Dil" label-for="languageCode">
                    <v-select-list
                        id="languageCode"
                        v-model="localValue.languageCode"
                        :options="languages"
                        :reduce="(lang) => lang.LanguageCode"
                        label="LanguageName"
                        placeholder="Tüm Diller (Global)"
                        clearable
                    />
                    <small class="text-muted">Boş bırakılırsa tüm diller için geçerli olur</small>
                </b-form-group>

                <b-form-group label="Açıklama" label-for="description">
                    <b-form-textarea id="description" v-model="localValue.description" placeholder="Bu ayarın ne işe yaradığını açıklayın" rows="2" />
                </b-form-group>

                <b-form-group label="Varsayılan Değer" label-for="defaultValue">
                    <b-form-input id="defaultValue" v-model="localValue.defaultValue" placeholder="Varsayılan değer" />
                </b-form-group>

                <b-form-group label="Durum" label-for="isActive">
                    <b-form-checkbox v-model="localValue.isActive" id="isActive" switch>
                        {{ localValue.isActive ? "Aktif" : "Pasif" }}
                    </b-form-checkbox>
                </b-form-group>
            </b-col>
        </b-row>
    </div>
</template>

<script>
import { BRow, BCol, BFormGroup, BFormInput, BFormTextarea, BFormInvalidFeedback, BFormCheckbox, BFormSpinbutton } from "bootstrap-vue";
import VSelectList from "@/components/VSelectList.vue";

export default {
    name: "ConfigurationForm",
    components: {
        BRow,
        BCol,
        BFormGroup,
        BFormInput,
        BFormTextarea,
        BFormInvalidFeedback,
        BFormCheckbox,
        BFormSpinbutton,
        VSelectList,
    },
    props: {
        value: {
            type: Object,
            required: true,
        },
        errors: {
            type: Object,
            default: () => ({}),
        },
        languages: {
            type: Array,
            default: () => [],
        },
        configGroups: {
            type: Array,
            default: () => [],
        },
    },
    data() {
        return {
            dataTypes: [
                { label: "String (Metin)", value: "string" },
                { label: "Number (Sayı)", value: "number" },
                { label: "Boolean (Açık/Kapalı)", value: "boolean" },
                { label: "JSON (Nesne)", value: "json" },
            ],
        };
    },
    computed: {
        localValue: {
            get() {
                return this.value;
            },
            set(val) {
                this.$emit("input", val);
            },
        },
        configValueAsNumber: {
            get() {
                return Number(this.localValue.configValue) || 0;
            },
            set(val) {
                this.localValue.configValue = String(val);
            },
        },

        configValueAsBoolean: {
            get() {
                return this.localValue.configValue === true || this.localValue.configValue === "true";
            },
            set(val) {
                this.localValue.configValue = String(val);
            },
        },
    },
    methods: {
        getValidationState(field) {
            return this.errors[field] ? false : null;
        },
    },
};
</script>

<style scoped>
.is-required >>> label::after,
.is-required /deep/ label::after {
    content: " *";
    color: #dc3545;
    font-weight: 700;
}
</style>
